<template>
  <div>
    <a-menu :style="{marginBottom: '20px'}" v-model="selectedKey" mode="horizontal">
      <a-menu-item @click="changeRoute(item.route)" v-for="(item, index) of menuList" :key="`${index}`">{{item.title}}</a-menu-item>
    </a-menu>

    <router-view :style="{backgroundColor: '#fff', padding: '24px'}"/>
  </div>
</template>

<script>
export default {
  name: 'anchor',
  data () {
    return {
      selectedKey: ['0'],
      KeyObj: {
        anchorManage: ['0'],
        anchorReview: ['1']
      },
      menuList: [
        { title: '主播管理', route: 'anchorManage' },
        { title: '主播审核', route: 'anchorReview' }
      ]
    };
  },
  watch: {
    $route (to, from) {
      let KeyObj = this.KeyObj;
      if (KeyObj[to.name]) {
        this.selectedKey = KeyObj[to.name];
      }
    }
  },
  created () {
    let KeyObj = this.KeyObj;
    if (KeyObj[this.$route.name]) {
      this.selectedKey = KeyObj[this.$route.name];
    }
  },
  mounted () {
  },
  methods: {
    /* 切换子路由 */
    changeRoute (route) {
      this.$router.push({ name: route });
    }
  }
};
</script>
